import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';

@Pipe({
  name: 'avatar',
  standalone: true,
})
export class AvatarPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(name: string | null | undefined): SafeUrl {
    if (!name) {
      return 'https://www.gravatar.com/avatar?d=identicon';
    }

    const initials = this.getInitials(name);
    const svg = this.generateSvg(initials);
    const blob = new Blob([svg], {type: 'image/svg+xml'});
    const url = URL.createObjectURL(blob);

    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  private getInitials(name: string): string {
    return name
      .split(' ')
      .map((n) => n[0])
      .slice(0, 2)
      .join('')
      .toUpperCase();
  }

  private generateSvg(initials: string): string {
    const backgroundColor = this.getColor(initials);
    const textColor = '#ffffff';

    return `
      <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg">
        <rect width="100" height="100" fill="${backgroundColor}" />
        <text x="50%" y="50%" dominant-baseline="central" text-anchor="middle" fill="${textColor}" font-size="40" font-family="sans-serif">
          ${initials}
        </text>
      </svg>
    `;
  }

  private getColor(initials: string): string {
    const colors = [
      '#489311', '#5cb917', '#2d3748', '#828d9f', '#ec776c',
      '#fb866a', '#15a362', '#0fd177', '#f5f6fe', '#fafbfc'
    ];
    const charCodeSum = initials.charCodeAt(0) + (initials.length > 1 ? initials.charCodeAt(1) : 0);
    return colors[charCodeSum % colors.length];
  }
}
